const pagesContractorCoreOperationPackagesEn = {
  addPattern: {
    addButtonLabel: 'Add operation package pattern',
    error: 'Failed to create operation package pattern',
    success: 'Operation package pattern created successfully'
  },
  assignTaskToPerson: {
    addPersonDialog: {
      description: 'Create a new person',
      title: 'Create new'
    },
    anchorDate: 'Anchor date',
    assignSuccess: 'Operation task assigned successfully',
    assignSuccessMessage: '{{count}} operation tasks assigned',
    selectPackage: 'Select operation package',
    selectPackageDescription: 'Select the operation package to assign',
    selectPackagePattern: 'Select operation package pattern',
    selectPackagePatternDescription: 'Select the operation package pattern to assign',
    selectPerson: 'Select target',
    selectPersonDescription: 'Select the target to assign',
    selectPersonPlaceholder: 'Select target',
    selectedOperationPackage: 'Selected operation package',
    selectedOperationPattern: 'Selected operation package pattern',
    selectedPerson: 'Selected target',
    startOperationTask: 'Start operation task',
    startOperationTaskDescription: 'Start the operation task by selecting the operation package and pattern, and then assigning the target.'
  },
  contractorCore: 'Contractor Core',
  demo: {
    description: 'This screen is a preview of the development. The actual function will be released in the future.',
    patternType: {
      cooperativeCompanyMember: 'Cooperative Company Member',
      employee: 'Employee',
      freelancer: 'Freelancer',
      outsource: 'Outsource'
    },
    title: 'Business contract partner core is currently under development.'
  },
  displayDataAggregate: 'Display: Data aggregate',
  filterByPerson: 'Filter by person',
  patternEmptyState: {
    description: 'No operation package pattern found. Please register from the Add pattern button above.',
    title: 'No operation package pattern'
  },
  sideTab: {
    close: 'Close side tab',
    demoItems: {
      contractRenewal: 'Contract Renewal & Period Management',
      contractSigning: 'Contract Signing & E-signature',
      contractTerms: 'Contract Terms Management',
      creditCheck: 'Credit Check',
      documentManagement: 'Document Management (PO/Invoice/Payment)',
      entryProcedure: 'Entry Procedure',
      payment: 'Payment Management',
      personnelEvaluation: 'Personnel Evaluation',
      workDelivery: 'Work & Delivery Management'
    },
    underDevelopment: 'This operation package is currently under development.'
  },
  startNew: 'Start new',
  status: {
    approval: 'Approval',
    approvalRequired: 'Approval Required',
    attachment: 'Attachment',
    completed: 'Completed',
    notRequired: 'Not Required',
    todo: 'Todo'
  },
  tabs: {
    archive: 'Archive',
    config: 'Config',
    operationPackages: 'Operation packages'
  },
  taskEmptyState: {
    description: 'No operation task found. Please register from the Add operation task button above.',
    title: 'No Operation task'
  }
};
export default pagesContractorCoreOperationPackagesEn;